import { initializeApp } from "firebase/app";
import config from "./config";

const firebaseApp = initializeApp(config.firebaseConfig);
export default firebaseApp;
